import React from 'react';

import classes from 'components/pages/ScheduleViewsPage/components/ViewConfiguration/components/ViewConfigurationDrawerForm/components/RowConfigView/components/Pill/Pill.module.scss';

export interface Props {
    label?: string;
    value: React.ReactNode;
    brokenReferenceLink?: boolean;
}

export const Pill = ({ label, value, brokenReferenceLink }: Props) => {
    return (
        <div className={[classes.pill, brokenReferenceLink ? classes.broken : ''].filter(Boolean).join(' ')}>
            {label && <span>{label}: </span>}
            <span className={classes.pillValue}>{value}</span>
        </div>
    );
};
